import { contactCard } from './contactCard';

export const escrowOfficerCard = contactCard(
  'additionalContacts.escrowOfficer',
  'escrowOfficer',
);
